import { ArrowUpRight } from "lucide-react";
import { BRAND } from "@/data/content";

export function FinalCta({ t }) {
    return (
        <section className="final-cta section" data-testid="reset365-final-cta-section">
            <div className="page-width final-cta__inner reveal">
                <p className="eyebrow eyebrow--light" data-testid="reset365-final-eyebrow">{t.eyebrow}</p>
                <h2 data-testid="reset365-final-title">{t.title}</h2>
                <p data-testid="reset365-final-body">{t.body}</p>
                <div className="final-cta__actions">
                    <a href="#soumission" className="button button--primary" data-testid="reset365-final-quote-btn">{t.primary}<ArrowUpRight size={16} aria-hidden="true" /></a>
                    <a href={BRAND.phoneHref} className="final-cta__phone" data-testid="reset365-final-call-btn">{t.secondary}</a>
                </div>
            </div>
        </section>
    );
}
